import { Layout, type LayoutProps } from "antd";
import clsx from "clsx";
import "./BLayout.scss";

const BLayout = ({ className, ...props }: LayoutProps) => (
  <Layout className={clsx("b-layout", className)} {...props} />
);

export default BLayout;
